import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

function InviteWealthPartner() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (value === "" || isValidEmail(value)) {
      setError("");
    } else {
      setError("Please enter a valid email address.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setError("Email must be valid to submit.");
      return;
    }
    // alert(`Submitted email: ${email}`);
    // Submit logic here

    const endpoint = `${base_url}/${api_type}/partners/invite`;

    try {
      const response = await axios.post(
        endpoint,
        { email: email },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("Invite partner response", response);
      setEmail("");
      toast.success(response?.data?.message);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.response.data.message);
    }
  };

  return (
    <div className="pt-14 pl-5">
      <div className="bg-white px-8 py-2 mt-4 rounded-[10px] border overflow-auto">
        <h1 className="text-[#252C32] text-[24px]">Invite Partner </h1>
      </div>

      <form
        onSubmit={handleSubmit}
        className="mx-auto w-full flex justify-center items-center mt-10 p-6 rounded-lg "
      >
        <div className="w-2/4">
          {/* <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            Admin Email Entry
          </h2> */}

          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Partner Email Address
          </label>

          <input
            id="email"
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="Enter  email"
            className={`w-full px-4 py-2 border ${
              error ? "border-red-500" : "border-gray-300"
            } rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
          />

          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

          <button
            type="submit"
            className="mt-4 w-full bg-[#035C98] text-white py-2 rounded-md  transition"
          >
            Invite
          </button>
        </div>
      </form>
    </div>
  );
}

export default InviteWealthPartner;
